import { api } from './Api';
import { S3ConnectionSettings } from '../models';

export const testS3Connection = (connection: S3ConnectionSettings) => {
  return api.post(`s3/test`, connection).then((res: any) => res.data);
}
